var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrActionbarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 413,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{stroke-width:2}.C{fill:#0057ff}.D{fill:rgba(255,255,255,0)}.E{stroke-width:1.5}.F{stroke-linejoin:round}.G{stroke:#0057ff}.H{stroke:rgba(0,87,255,0.5)}.I{stroke-linecap:round}.J{stroke-linecap:square}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "A",
    x: 0,
    y: 0,
    width: 152,
    height: 413
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "A"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "A"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.034-24A7.034,7.034,0,0,0,15-16.966a7.034,7.034,0,0,0,7.034,7.034,7.034,7.034,0,0,0,7.034-7.034A7.034,7.034,0,0,0,22.034-24Zm0,1.759a5.276,5.276,0,0,1,5.276,5.276,5.276,5.276,0,0,1-5.276,5.276,5.276,5.276,0,0,1-5.276-5.276A5.276,5.276,0,0,1,22.034-22.241Z",
    transform: "translate(-15 24)",
    className: "C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.471-15.056a3.48 3.48 0 0 0 2.943 1.582c1.188.029 2.309-.548 2.976-1.532a.66.66 0 0 1 .912-.2.66.66 0 0 1 .2.912 4.81 4.81 0 0 1-4.1 2.137 4.8 4.8 0 0 1-4.054-2.209.66.66 0 0 1 .215-.907.66.66 0 0 1 .908.217zm.758-3.694a1.5 1.5 0 0 1 1.539 1.469.66.66 0 0 1-.659.659.66.66 0 0 1-.659-.659c0-.07-.087-.15-.22-.15s-.22.08-.22.15a.66.66 0 0 1-.659.659.66.66 0 0 1-.659-.659 1.5 1.5 0 0 1 1.536-1.469zm4.4 0a1.5 1.5 0 0 1 1.539 1.469.66.66 0 0 1-.659.659.66.66 0 0 1-.659-.659c0-.07-.087-.15-.22-.15s-.22.08-.22.15a.66.66 0 0 1-.659.659.66.66 0 0 1-.659-.659 1.5 1.5 0 0 1 1.533-1.469z",
    transform: "translate(-18.25 18.75)",
    className: "C"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48 -32)",
    filter: "url(#A)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 317,
    rx: 28,
    transform: "translate(48 32)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14 20.999h28v28H14z",
    className: "D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 36.297l3.53 3.452 8.78-8.793",
    className: "B G J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.922 28.613c-3.361-2.225-7.803-1.88-10.781.836s-3.728 7.108-1.82 10.659 5.984 5.35 9.892 4.367 6.648-4.497 6.649-8.527c0-.395-.026-.789-.079-1.18",
    className: "E H"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14 69.999h28v28H14z",
    className: "D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.193 77.913h6.829a2.64 2.64 0 0 1 2.638 2.638v9.672a2.64 2.64 0 0 1-2.638 2.638H24.35a2.64 2.64 0 0 1-2.638-2.638v-6.994",
    className: "E H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "B G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.552 89.344h9.672",
    className: "F I"
  }), /*#__PURE__*/React.createElement("g", {
    className: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.276 77.913h5.276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.914 75.275v5.276"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M14 119.999h28v28H14z",
    className: "D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.237 127.913h6.785a2.64 2.64 0 0 1 2.638 2.638v.627m0 1.808v7.237c-.001.424-.103.841-.3 1.216m-12.01 1.422a2.64 2.64 0 0 1-2.638-2.638v-6.953",
    className: "E H"
  }), /*#__PURE__*/React.createElement("g", {
    className: "G B"
  }, /*#__PURE__*/React.createElement("g", {
    className: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.276 127.913h5.276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.914 125.275v5.276"
  })), /*#__PURE__*/React.createElement("g", {
    className: "F I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.425 139.643l3.041-5.575 5.276 9.672H27.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.586 143.74h-7.034l3.517-6.155 2.093 3.662"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.422 133.189a1.32 1.32 0 0 0 1.319-1.319 1.32 1.32 0 0 0-1.319-1.319 1.32 1.32 0 0 0-.933 2.252 1.32 1.32 0 0 0 .933.386z",
    className: "F"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14 168.999h28v28H14z",
    className: "D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    className: "E F H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.983 180.978v8.245a2.64 2.64 0 0 1-2.638 2.635h-9.672",
    className: "I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.127 189.913a2.64 2.64 0 0 1-.092-.69v-6.955m5.283-5.355h6.257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.819 179.287l-7.956 7.943m0 3.488c-.96-.965-.96-2.523 0-3.488a2.45 2.45 0 0 1-1.737.722 1.79 1.79 0 0 1-1.42-.722",
    className: "I"
  })), /*#__PURE__*/React.createElement("g", {
    className: "B G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.87 180.946l-5.03 4.929-5.43 5.238-4.815 1.1 1.134-4.672 1.366-1.322 8.959-8.692.986-.958a2.36 2.36 0 0 1 3.42.256 2.96 2.96 0 0 1 .845 1.386",
    className: "F I"
  }), /*#__PURE__*/React.createElement("g", {
    className: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.397 176.913h5.276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.035 174.275v5.276"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M14 217.999h28v28H14z",
    className: "D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.47 225.034h6.793a2.64 2.64 0 0 1 2.638 2.638v2.062m-6.769 10.248h-5.541a2.64 2.64 0 0 1-2.638-2.638v-7.025",
    fill: "none",
    className: "E H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.625 228.999v-2.625H17v-1.75h2.625v-2.625h1.75v2.625H24v1.75h-2.625v2.625z",
    className: "C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.552 227.672)",
    clipPath: "url(#B)",
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.879-.879h15.827v15.827H-.879z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.409 232.288)",
    clipPath: "url(#C)",
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.972-.879h10.3v8.368h-10.3z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14 266.999h28v28H14z",
    className: "D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.026 288.981c.413 0 .839-.04 1.268-.116l.187-.921.346-.086c.616-.155 1.198-.387 1.733-.689l.302-.172.782.521c.358-.248.69-.523.986-.82s.57-.626.82-.986l-.501-.753.182-.306c.326-.544.575-1.131.743-1.743l.092-.337.901-.181a7.27 7.27 0 0 0 .116-1.275c.001-.418-.038-.847-.116-1.276l-.88-.176-.088-.344a6.98 6.98 0 0 0-.716-1.755l-.176-.304.513-.77a7.15 7.15 0 0 0-.821-.987 7.25 7.25 0 0 0-.984-.819l-.766.509-.304-.177c-.536-.314-1.116-.554-1.722-.716l-.339-.09-.19-.942c-.86-.155-1.69-.155-2.55 0l-.19.942-.34.09c-.594.158-1.16.391-1.684.693l-.303.175-.832-.554a7.04 7.04 0 0 0-.985.82c-.295.293-.57.624-.821.986l.551.828-.177.304a6.96 6.96 0 0 0-.693 1.649l-.092.336-1.004.203a6.99 6.99 0 0 0-.118 1.275 7.09 7.09 0 0 0 .116 1.276l.984.198.088.343c.155.591.378 1.151.666 1.663l.171.302-.562.845c.249.358.523.69.82.984s.625.571.986.821l.815-.543.305.182c.526.313 1.088.555 1.672.72l.332.094.194.962c.427.078.854.118 1.27.118h.014m0 2h-.014c-.535 0-1.083-.051-1.629-.15a2 2 0 0 1-1.553-1.383l-.503-.216a2 2 0 0 1-2.042-.14c-.462-.32-.886-.673-1.261-1.051s-.729-.797-1.048-1.257a2 2 0 0 1-.107-2.109l-.189-.471a2 2 0 0 1-1.376-1.555c-.1-.551-.149-1.1-.148-1.632a9 9 0 0 1 .15-1.636 2 2 0 0 1 1.416-1.562l.196-.468a2 2 0 0 1 .127-2.07 9.06 9.06 0 0 1 1.052-1.262 9.05 9.05 0 0 1 1.26-1.049 2 2 0 0 1 2.079-.119l.509-.209a2 2 0 0 1 1.545-1.341c.545-.098 1.093-.148 1.63-.148s1.085.05 1.63.148a2 2 0 0 1 1.545 1.342l.566.235a2 2 0 0 1 1.998.166 9.26 9.26 0 0 1 1.255 1.046 9.16 9.16 0 0 1 1.051 1.263 2 2 0 0 1 .157 2.005l.248.609a2 2 0 0 1 1.264 1.515c.1.55.15 1.1.149 1.635a9.27 9.27 0 0 1-.148 1.626 2 2 0 0 1-1.308 1.535l-.257.605a2 2 0 0 1-.178 1.969c-.319.459-.671.882-1.048 1.259-.383.383-.808.736-1.263 1.051a2 2 0 0 1-2.032.143l-.57.227a2 2 0 0 1-1.532 1.299 9.23 9.23 0 0 1-1.621.148z",
    className: "C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 280.999,
    r: 3,
    fill: "none",
    opacity: 0.5,
    className: "E F G"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrActionbarUser);
export default __webpack_public_path__ + "static/media/scrumlr_actionbar_user.8c8cd24f4771d8b911462ec075c14a50.svg";
export { ForwardRef as ReactComponent };